<template>
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_508_10702)">
      <path
        d="M13.9035 1.68172C13.6881 1.77728 13.4665 1.85792 13.2402 1.9234C13.5082 1.62036 13.7125 1.26379 13.8372 0.873592C13.8651 0.786131 13.8362 0.690396 13.7643 0.633194C13.6925 0.575948 13.5927 0.569091 13.5137 0.615941C13.033 0.901021 12.5144 1.10589 11.9707 1.2257C11.4229 0.690485 10.679 0.385895 9.90995 0.385895C8.28658 0.385895 6.96585 1.70658 6.96585 3.32991C6.96585 3.45776 6.97394 3.58491 6.98996 3.71028C4.97551 3.53341 3.10271 2.54328 1.81667 0.965744C1.77084 0.909515 1.70023 0.879211 1.62794 0.885006C1.55561 0.890669 1.49062 0.931458 1.45408 0.994145C1.19324 1.44172 1.05535 1.95361 1.05535 2.47445C1.05535 3.18383 1.30862 3.85689 1.75602 4.38281C1.61998 4.3357 1.48797 4.27681 1.36197 4.20687C1.29433 4.16922 1.21178 4.1698 1.14458 4.20833C1.07734 4.24686 1.03518 4.31774 1.03341 4.3952C1.0331 4.40825 1.0331 4.4213 1.0331 4.43453C1.0331 5.4934 1.60299 6.44672 2.47429 6.96632C2.39944 6.95884 2.32463 6.948 2.2503 6.9338C2.17368 6.91916 2.09489 6.94601 2.04322 7.00445C1.99146 7.06285 1.97434 7.14425 1.99818 7.21857C2.32069 8.22547 3.15102 8.96608 4.15482 9.19188C3.32227 9.71333 2.37019 9.98647 1.37073 9.98647C1.16219 9.98647 0.952448 9.97421 0.747176 9.94993C0.645204 9.93781 0.5477 9.99802 0.512972 10.095C0.478243 10.192 0.515051 10.3002 0.601805 10.3558C1.88577 11.179 3.37041 11.6142 4.89512 11.6142C7.89253 11.6142 9.76763 10.2007 10.8128 9.01497C12.1161 7.53643 12.8636 5.57941 12.8636 3.64574C12.8636 3.56495 12.8623 3.48338 12.8598 3.40206C13.374 3.01466 13.8167 2.54581 14.177 2.00692C14.2317 1.92508 14.2258 1.81691 14.1624 1.74157C14.0991 1.66619 13.9936 1.64181 13.9035 1.68172Z"
        fill="#040325"
      />
    </g>
    <defs>
      <clipPath id="clip0_508_10702">
        <rect
          width="13.7143"
          height="12"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
